import React from "react"
import autobind from "class-autobind"
import ChooseHierarchyPickerDialog from "./ChooseHierarchyPickerDialog"
import HierarchyItemChip from "../HierarchyItemChip"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as hierarchySettingsActions from "../../../actions/HierarchySettingsActions"
import { IHierarchyItem, IUIUser } from "../../../models"
import { red500 } from "material-ui/styles/colors"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import AccountStore from "../../../stores/AccountStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as punchHelper from "../../../helpers/punchHelper"
interface IProps {
    readonly?: boolean
    chipLabel: string
    errorChipText?: string
    hierarchyItemId: string
    chipMaxWidth?: number

    // if hierarchy is invalid, we need to open the PickerDialog with employee's DefaultHierarchyItemId
    employee?: IUIUser
    handleSelectHierarchy(hierarchyItemId: string, intentionalChanged: boolean): void
    customeOpenDialog?(): void

    // if not define it, SsupervisorClickableAccessHierarchy by default
    getClickableAccessHierarchies?(): string[]

    // these are for PickerDialog error message.
    //if getCustomNoAccessErrorStr is exist, don't need getAccessRight
    getAccessRight?(selectedHierarchy: IHierarchyItem): boolean
    getCustomNoAccessErrorStr?(selectedHierarchy: IHierarchyItem): string

    //if Clock device's hierarchy removed, we should open with global filter hierarchy.
    openWithGlobalFilerWhenSelectedHierarchyIsInvalid?: boolean

    //GlobalPunch Add/Edit
    isGlobalPunch?: boolean
    globalPunchEmployees?: IUIUser[]

    //Employee->Timecard->PunchDrawerTable
    isPunchListTable?: boolean
    hierarchyColWidth?: number
}
interface IState {
    hierarchyItemId: string
    openChooseHierarchyPickerDialog: boolean
}

export default class ChooseHierarchyChip extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            hierarchyItemId: props.hierarchyItemId,
            openChooseHierarchyPickerDialog: false
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.hierarchyItemId !== nextProps.hierarchyItemId &&
            this.setState({ hierarchyItemId: nextProps.hierarchyItemId })
    }

    render() {
        return (
            <div style={{ position: "relative" }}>
                <HierarchyItemChip
                    maxWidth={this.props.chipMaxWidth}
                    title={this.props.chipLabel}
                    hierarchyItemId={this.props.hierarchyItemId}
                    onClick={() => {
                        if (this.props.readonly) return
                        const defaultHierarchyForPickerDialog =
                            this.state.hierarchyItemId === AccountStore.DiffHierarchyLevel ?
                                this.props.isGlobalPunch ?
                                    punchHelper.getDefaultGlobalPunchHierarchy(this.props.globalPunchEmployees) :
                                    AuthenticationStore.getLoggedInUser().OrganizationHierarchyId :
                                hierarchyHelper.detectValidHierarchy(this.state.hierarchyItemId) ?
                                    this.state.hierarchyItemId :
                                    this.props.openWithGlobalFilerWhenSelectedHierarchyIsInvalid ?
                                        HierarchySettingsStore.getGlobalLevelItemFilterId() :
                                        this.props.employee.DefaultHierarchyItemId

                        if (this.props.customeOpenDialog) {
                            this.props.customeOpenDialog()
                            hierarchySettingsActions.receiveHierarchySelectedItem(hierarchyHelper.getHierarchyItemById(defaultHierarchyForPickerDialog))
                        }
                        else {
                            this.setState({ openChooseHierarchyPickerDialog: true })
                            hierarchySettingsActions.receiveHierarchySelectedItem(hierarchyHelper.getHierarchyItemById(defaultHierarchyForPickerDialog))
                        }
                    }}
                    isPunchListTable={this.props.isPunchListTable}
                    hierarchyColWidth={this.props.hierarchyColWidth}
                    error={this.props.isPunchListTable && this.props.errorChipText ? true : false}
                />
                {!this.props.isPunchListTable &&
                    <div style={{ position: "absolute", bottom: -20, width: "max-content", fontSize: 11, color: red500 }}>
                        {this.props.errorChipText}
                    </div>
                }
                {this.state.openChooseHierarchyPickerDialog &&
                    <ChooseHierarchyPickerDialog
                        getCustomNoAccessErrorStr={this.props.getCustomNoAccessErrorStr}
                        handleSave={hierarchy => this.setState({ hierarchyItemId: hierarchy ? hierarchy.Id : null },
                            () => this.props.handleSelectHierarchy(this.state.hierarchyItemId, this.props.hierarchyItemId !== this.state.hierarchyItemId))
                        }
                        handleClose={() => this.setState({ openChooseHierarchyPickerDialog: false })}
                        getClickableAccessHierarchies={this.props.getClickableAccessHierarchies}
                        getAccessRight={this.props.getAccessRight}
                    />
                }
            </div>
        )
    }


}